import React, { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";

import { Box, Button, ListItemIcon, MenuItem } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import FactCheckIcon from "@mui/icons-material/FactCheck";

import EstimationColumns from "./estimationColumns";

import {
  pvEstimationTableProps,
  pvEstimationHeadCellSx,
  pvEstimationBodyCellSx,
  withPvEstimationStyles,
  useResponsivePvEstimationColumns,
} from "./pvEstimationTableStyles";

const ESTIMATION_COLUMN_WEIGHTS = {
  "WBS Code": 0.85,
  Description: 2.2,
  Unit: 0.8,

  "Est Weight": 1,
  "Est Unit Rate": 1,
  "Est Cost": 1,
};
const EstimationTable = (props) => {
  const {
    rows,
    handleSaveCell,
    handleCreateNewRow,
    handleDeleteRow,
    isLoading,
    getValues,
    handleCompareCost,
    handleCheckStock,
  } = props;

  const columns = useMemo(
    () => withPvEstimationStyles(EstimationColumns(getValues, handleSaveCell)),
    [getValues, handleSaveCell],
  );

  const {
    viewportRef,
    tableWidth,
    responsiveColumns,
    actionsWidth,
    columnSizing,
  } = useResponsivePvEstimationColumns({
    columns,
    columnWeights: ESTIMATION_COLUMN_WEIGHTS,

    actionsWeight: 0.45,
  });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MaterialReactTable
        {...pvEstimationTableProps}
        columns={responsiveColumns}
        data={rows ?? []}
        getRowId={(originalRow, index) =>
          originalRow.__rowId ?? `${index}-${originalRow.Description ?? ""}`
        }
        enableEditing={false}
        enableSorting={false}
        enableColumnActions={false}
        enableTopToolbar={false}
        enableRowActions
        positionActionsColumn="last"
        layoutMode="grid-no-grow"
        enableColumnResizing={false}
        defaultColumn={{
          size: 1,
          minSize: 1,
          maxSize: 100000,
          grow: false,
        }}
        muiTableProps={{
          sx: {
            width: `${tableWidth}px !important`,

            minWidth: `${tableWidth}px !important`,

            maxWidth: `${tableWidth}px !important`,
          },
        }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "Actions",

            size: actionsWidth,
            minSize: actionsWidth,
            maxSize: actionsWidth,

            grow: false,

            muiTableHeadCellProps: {
              sx: {
                ...pvEstimationHeadCellSx,

                width: `${actionsWidth}px !important`,

                minWidth: `${actionsWidth}px !important`,

                maxWidth: `${actionsWidth}px !important`,

                flex: `0 0 ${actionsWidth}px !important`,
              },
            },

            muiTableBodyCellProps: {
              sx: {
                ...pvEstimationBodyCellSx,

                width: `${actionsWidth}px !important`,

                minWidth: `${actionsWidth}px !important`,

                maxWidth: `${actionsWidth}px !important`,

                flex: `0 0 ${actionsWidth}px !important`,
              },
            },
          },
        }}
        renderBottomToolbarCustomActions={() => (
          <Button
            color="primary"
            size="small"
            onClick={() => handleCreateNewRow()}
            variant="contained"
          >
            Add row
          </Button>
        )}
        renderRowActionMenuItems={({ row }) => [
          <MenuItem
            key="delete"
            sx={{ m: 0 }}
            onClick={() => handleDeleteRow(row.index)}
          >
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            Delete
          </MenuItem>,

          <MenuItem
            key="compare"
            sx={{ m: 0 }}
            onClick={() => handleCompareCost(row.original)}
          >
            <ListItemIcon>
              <CompareArrowsIcon />
            </ListItemIcon>
            Compare Cost
          </MenuItem>,

          <MenuItem
            key="availability"
            sx={{ m: 0 }}
            onClick={() => handleCheckStock(row.original)}
          >
            <ListItemIcon>
              <FactCheckIcon />
            </ListItemIcon>
            Check availability
          </MenuItem>,
        ]}
        initialState={{
          pagination: {
            pageSize: 30,
            pageIndex: 0,
          },
        }}
        state={{
          isLoading,
          columnSizing,
        }}
      />
    </Box>
  );
};

export default EstimationTable;
